export default function TrekHighlights({ trek }) {
  const highlights = trek.highlights || []
  if (!highlights.length) return null

  return (
    <div style={{
      marginBottom: '48px', background: 'var(--green-light)', border: '1px solid var(--color-rule)',
      borderRadius: 'var(--radius-lg)', padding: '28px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
        <span style={{ fontSize: '20px' }}>🏔️</span>
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: 'var(--green-dark)' }}>Trip highlights</h3>
      </div>
      <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '10px 24px' }}>
        {highlights.map(h => (
          <li key={h} style={{ fontSize: '13px', color: 'var(--ink-mid)', lineHeight: 1.5, display: 'flex', gap: '8px' }}>
            <span style={{ color: 'var(--green)' }}>•</span>{h}
          </li>
        ))}
      </ul>
    </div>
  )
}
